<script setup>
import { useRoute, useRouter } from 'vue-router'
import { onMounted, provide, ref } from 'vue'
import { getCompiledPoll } from '@/services/compiledPollService.js'
import { splitSuppliers } from '@/libs/utils.js'

import PollComponent from '@/components/CMB/Components/PollComponent.vue'
import ButtonTornaAllaLista from '@/components/Generics/Buttons/ButtonTornaAllaLista.vue'
import Loading from '@/components/Generics/Loadings/Loading.vue'

const route = useRoute()
const router = useRouter()
const props = defineProps(['updatePageTitle'])
const compiledPollId = route['params']['id']
let compiledPoll = ref(null)
let isLoading = ref(true)
let form = ref(null)
let networkError = ref({
  enabled: false,
  message: 'Errore nel caricamento dei dati, riprova più tardi'
})

onMounted(async () => {
  isLoading = true

  try {
    compiledPoll.value = await getCompiledPoll(compiledPollId)
  } catch (error) {
    if(error.data.status === 403) {
      router.replace({ path: '/admin/error_403' })
    }

    if(error.data.status === 404) {
      router.replace({ path: '/admin/error_404' })
    }
  }

  let pageTitle = splitSuppliers(compiledPoll.value['attributes']['gec.suppliers']) + ' - ' + compiledPoll.value['poll']['title']
  props.updatePageTitle(pageTitle)
  isLoading = false
})

provide('questionsErrors', [])
</script>

<template>
  <div class="container-fluid" v-if="compiledPoll">
    <div class="row">
      <div class="col-12 px-0">
        <div class="card">
          <div class="card-body scrollable-body">
            <div
              v-if="networkError.enabled"
              class="alert alert-danger mt-2"
              role="alert"
            >
              {{ networkError.message }}
            </div>

            <loading v-if="isLoading"></loading>

            <form @submit.prevent="() => {}" ref="form">
              <poll-component
                v-if="compiledPoll"
                :compiled-poll="compiledPoll"
                :handle-answer="null"
                :form="form"
              ></poll-component>
            </form>
          </div>
        </div>

        <div class="d-flex mt-2 justify-content-between">
          <router-link
            :to="{
              name: 'admin/CMB_CompiledPoll',
              query: { page: route.query.page, filters: route.query.filters },
            }"
          >
            <button-torna-alla-lista></button-torna-alla-lista>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

:root,
:host {
  @extend :root;
}

[class*='fa-'] {
  width: 0.9rem;
}
</style>
